import onReady from './modules/onReady.min.js';
import handleUpload from './modules/handleUpload.min.js';

onReady(() => {
    handleUpload();
});
